import React from "react";
import { useNavigate } from "react-router-dom";
import AddSalarySetupForm from "./components/AddSalarySetupForm";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import { Create } from "adminApi/SalarySetupApi/SalarySetup";

const AddSalarySetup = () => {
    const navigate = useNavigate();
    const initialValues = {
        employee_id: "",
        salary_data: [],
    };

    const { 
        values, 
        handleChange, 
        setValues, 
        errors, 
        setErrors 
    } = useFormChange(initialValues);

    const { handleSubmit, loading } = useFormSubmit(
        async (vals) => await Create({ data: vals }),
        (vals) => {
            const err = {};
            if (!vals.employee_id) err.employee_id = "Employee is required";
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Salary Setup created successfully"
    );

    return (
        <AddSalarySetupForm
            values={values}
            handleChange={handleChange}
            setValues={setValues}
            handleSubmit={(e) => handleSubmit(e, values)}
            loading={loading}
            errors={errors}
            setErrors={setErrors}
        />
    );
};

export default AddSalarySetup;
